(function(){
  document.querySelectorAll('[data-market-switcher]').forEach(function(switcher){
    var form=switcher.querySelector('form');
    var trigger=switcher.querySelector('[data-market-trigger]');
    var menu=switcher.querySelector('[data-market-menu]');
    var countrySelect=switcher.querySelector('[data-market-select]');
    var languageInput=switcher.querySelector('[data-market-language]');
    function close(){
      if(!menu || !trigger) return;
      menu.hidden=true;
      trigger.setAttribute('aria-expanded','false');
    }
    function open(){
      if(!menu || !trigger) return;
      menu.hidden=false;
      trigger.setAttribute('aria-expanded','true');
    }
    if(trigger && menu){
      trigger.addEventListener('click',function(event){
        event.preventDefault();
        menu.hidden ? open() : close();
      });
      document.addEventListener('click',function(event){
        if(!switcher.contains(event.target)) close();
      });
      document.addEventListener('keydown',function(event){
        if(event.key === 'Escape') close();
      });
    }
    switcher.querySelectorAll('[data-market-option]').forEach(function(option){
      option.addEventListener('click',function(){
        if(countrySelect) countrySelect.value=option.getAttribute('data-country-code') || '';
        if(languageInput) languageInput.value=option.getAttribute('data-language') || languageInput.value;
        if(form) form.submit();
      });
    });
    if(countrySelect){
      countrySelect.addEventListener('change',function(){
        var selected=countrySelect.options[countrySelect.selectedIndex];
        if(languageInput && selected && selected.dataset.language) languageInput.value=selected.dataset.language;
        if(form) form.submit();
      });
    }
  });

  function refreshCartCount(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      document.querySelectorAll('[data-cart-count]').forEach(function(node){node.textContent=cart.item_count;});
    }).catch(function(){});
  }

  document.querySelectorAll('[data-gallery]').forEach(function(gallery){
    var slides=[].slice.call(gallery.querySelectorAll('[data-slide]'));
    var thumbs=[].slice.call(gallery.querySelectorAll('[data-thumb]'));
    var active=0;
    function show(index){
      if(!slides.length) return;
      active=(index+slides.length)%slides.length;
      slides.forEach(function(slide,i){slide.classList.toggle('is-active',i===active);});
      thumbs.forEach(function(thumb,i){
        var isActive=i===active;
        thumb.classList.toggle('is-active',isActive);
        thumb.setAttribute('aria-current',isActive ? 'true' : 'false');
        if(isActive && typeof thumb.scrollIntoView === 'function'){
          thumb.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
        }
      });
    }
    thumbs.forEach(function(thumb,i){thumb.addEventListener('click',function(){show(i);});});
    var prev=gallery.querySelector('[data-prev]');
    var next=gallery.querySelector('[data-next]');
    if(prev) prev.addEventListener('click',function(){show(active-1);});
    if(next) next.addEventListener('click',function(){show(active+1);});
  });

  var deferredVideos=[].slice.call(document.querySelectorAll('[data-deferred-video]'));
  if(deferredVideos.length){
    var loadDeferredVideo=function(video){
      if(!video || video.dataset.videoLoaded === 'true') return;
      var src=video.getAttribute('data-src');
      if(!src) return;
      video.dataset.videoLoaded='true';
      video.src=src;
      video.load();
      if(video.autoplay){
        var playPromise=video.play();
        if(playPromise && typeof playPromise.catch === 'function') playPromise.catch(function(){});
      }
    };
    if('IntersectionObserver' in window){
      var videoObserver=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){
            loadDeferredVideo(entry.target);
            videoObserver.unobserve(entry.target);
          }
        });
      },{rootMargin:'450px 0px'});
      deferredVideos.forEach(function(video){videoObserver.observe(video);});
    }else{
      window.addEventListener('load',function(){
        deferredVideos.forEach(loadDeferredVideo);
      });
    }
  }

  var productPage=document.querySelector('[data-product-page]');
  if(productPage){
    var productCopy={
      atc: productPage.getAttribute('data-copy-atc') || 'Add to cart',
      soldOut: productPage.getAttribute('data-copy-sold-out') || 'Sold out',
      sticky: productPage.getAttribute('data-copy-sticky') || 'Choose your bundle',
      showMore: productPage.getAttribute('data-copy-show-more') || 'Show more reviews',
      showFewer: productPage.getAttribute('data-copy-show-fewer') || 'Show fewer reviews',
      offerName: productPage.getAttribute('data-property-offer-name') || 'Offer',
      offerValue: productPage.getAttribute('data-property-offer-value') || '1x Mistglide Brush + 1 free',
      freeOfferValue: productPage.getAttribute('data-property-free-offer-value') || 'Free Mistglide Brush',
      serumGiftValue: productPage.getAttribute('data-property-serum-gift-value') || 'Free serum gift',
      colorOneName: productPage.getAttribute('data-property-color-one-name') || 'Brush 1 color',
      colorTwoName: productPage.getAttribute('data-property-color-two-name') || 'Free brush color'
    };
    var serumGiftVariantId=Number(productPage.getAttribute('data-serum-gift-variant-id') || 0);
    var variantsNode=document.querySelector('[data-product-variants]');
    var variants=[];
    try{variants=JSON.parse(variantsNode ? variantsNode.textContent : '[]');}catch(e){}
    var variantInput=document.querySelector('[data-variant-id]');
    var colorOneLabel=document.querySelector('[data-color-label-one]');
    var colorTwoLabel=document.querySelector('[data-color-label-two]');
    var propOne=document.querySelector('[data-property-color-one]');
    var propTwo=document.querySelector('[data-property-color-two]');
    var priceNode=document.querySelector('[data-price]');
    var compareNode=document.querySelector('[data-compare]');
    var form=document.querySelector('[data-product-form]');
    var stickyAtc=document.querySelector('[data-sticky-atc]');
    var stickyAtcPrice=document.querySelector('[data-sticky-atc-price]');
    var bundleTarget=document.querySelector('[data-bundle-target]');
    var trustBadges=[].slice.call(document.querySelectorAll('.sc-trust p'));

    if(trustBadges[0] && /free delivery/i.test(trustBadges[0].textContent || '')) trustBadges[0].textContent='5-year guarantee';
    function money(cents){
      var config=window.HydraBrushMoney || {};
      var amount=Number(cents || 0)/100;
      var currency=String(config.currency || 'EUR').toUpperCase();
      if(currency === 'EUR'){
        try{
          return new Intl.NumberFormat('fr-FR', {
            minimumFractionDigits:2,
            maximumFractionDigits:2
          }).format(amount).replace(/\u202f/g, ' ') + ' €';
        }catch(e){
          return amount.toFixed(2).replace('.', ',') + ' €';
        }
      }
      try{
        return new Intl.NumberFormat(config.locale || document.documentElement.lang || 'en', {
          style:'currency',
          currency:currency
        }).format(amount);
      }catch(e){
        return amount.toFixed(2);
      }
    }
    function setMainVariant(input){
      var variant=variants.filter(function(v){return String(v.id)===String(input.value);})[0];
      if(!variant) return;
      if(variantInput) variantInput.value=variant.id;
      var colorDisplay=input.getAttribute('data-color-display') || input.getAttribute('data-color-name') || variant.option1;
      if(colorOneLabel) colorOneLabel.textContent=colorDisplay;
      if(propOne) propOne.value=colorDisplay;
      if(priceNode) priceNode.textContent=money(variant.price);
      if(compareNode) compareNode.textContent=money(variant.compare_at_price || 8990);
      if(stickyAtcPrice) stickyAtcPrice.textContent=money(variant.price);
      var atc=document.querySelector('.atc,.sc-atc');
      if(atc){
        atc.disabled=!variant.available;
        atc.innerHTML=variant.available ? productCopy.atc + ' - <span data-sc-atc-price>' + money(variant.price) + '</span>' : productCopy.soldOut;
      }
      if(stickyAtc){
        stickyAtc.disabled=!variant.available;
        stickyAtc.innerHTML=variant.available ? productCopy.sticky + '&nbsp;<span data-sticky-atc-price>' + money(variant.price) + '</span>' : productCopy.soldOut;
        stickyAtcPrice=stickyAtc.querySelector('[data-sticky-atc-price]');
      }
    }
    document.querySelectorAll('[data-color-one]').forEach(function(input){
      input.addEventListener('change',function(){setMainVariant(input);});
    });
    document.querySelectorAll('[data-color-two]').forEach(function(input){
      input.addEventListener('change',function(){
        var name=input.getAttribute('data-color-display') || input.getAttribute('data-color-name') || input.value;
        if(colorTwoLabel) colorTwoLabel.textContent=name;
        if(propTwo) propTwo.value=name;
      });
    });
    var selectedTwo=document.querySelector('[data-color-two]:checked');
    if(selectedTwo && propTwo) propTwo.value=selectedTwo.getAttribute('data-color-display') || selectedTwo.getAttribute('data-color-name') || selectedTwo.value;

    if(form){
      if(stickyAtc){
        stickyAtc.addEventListener('click',function(){
          var target=bundleTarget || form;
          if(!target) return;
          target.scrollIntoView({behavior:'smooth',block:'center'});
          var firstChoice=target.querySelector('[data-color-one]');
          if(firstChoice) {
            setTimeout(function(){ firstChoice.focus({preventScroll:true}); }, 450);
          }
        });

        if(bundleTarget && 'IntersectionObserver' in window){
          var stickyObserver=new IntersectionObserver(function(entries){
            entries.forEach(function(entry){
              stickyAtc.classList.toggle('is-hidden', entry.isIntersecting);
            });
          }, {threshold:0.28});
          stickyObserver.observe(bundleTarget);
        }
      }

      form.addEventListener('submit',function(event){
        event.preventDefault();
        if(form.dataset.atcBusy === 'true') return;
        form.dataset.atcBusy = 'true';
        var atcButton = form.querySelector('[type="submit"], .sc-atc, .atc');
        if(atcButton) atcButton.disabled = true;
        var paidVariantId=variantInput ? variantInput.value : '';
        var selectedFree=document.querySelector('[data-color-two]:checked');
        var freeVariantId=selectedFree ? selectedFree.getAttribute('data-free-variant-id') : paidVariantId;
        var paidColor=propOne ? propOne.value : '';
        var freeColor=propTwo ? propTwo.value : '';
        var replaceVariantIds=variants.map(function(variant){return Number(variant.id);}).filter(Boolean);
        var paidProperties={};
        paidProperties[productCopy.offerName]=productCopy.offerValue;
        paidProperties[productCopy.colorOneName]=paidColor;
        paidProperties[productCopy.colorTwoName]=freeColor;
        var freeProperties={_gift:'true',gift_free:'true'};
        freeProperties[productCopy.offerName]=productCopy.freeOfferValue;
        freeProperties[productCopy.colorTwoName]=freeColor;
        var serumProperties={_gift:'true',gift_free:'true',gift_serum:'true'};
        serumProperties[productCopy.offerName]=productCopy.serumGiftValue;
        var payload={
          items:[
            {
              id:Number(paidVariantId),
              quantity:1,
              properties:paidProperties
            },
            {
              id:Number(freeVariantId),
              quantity:1,
              properties:freeProperties
            }
          ]
        };
        if(serumGiftVariantId){
          payload.items.push({
            id:serumGiftVariantId,
            quantity:1,
            properties:serumProperties
          });
        }
        document.dispatchEvent(new CustomEvent('cart:add',{
          detail:{
            items:payload.items,
            source:'product-bogo',
            replaceVariantIds:replaceVariantIds,
            onSuccess:function(){
              refreshCartCount();
              form.dataset.atcBusy = 'false';
              if(atcButton) atcButton.disabled = false;
            },
            onError:function(error){
              console.error('Product add-to-cart failed', error);
              form.dataset.atcBusy = 'false';
              if(atcButton) atcButton.disabled = false;
            }
          }
        }));
      });
    }

    var serumGiftWidget=document.querySelector('[data-serum-gift-widget]');
    if(serumGiftWidget){
      var serumCountNode=serumGiftWidget.querySelector('[data-serum-gift-count]');
      var serumInitial=Number(serumGiftWidget.getAttribute('data-serum-gift-initial') || 13);
      var serumTotal=Number(serumGiftWidget.getAttribute('data-serum-gift-total') || 50);
      var serumKey='mistglide_serum_gift_stock_v1';
      var serumFloor=5;
      var serumMinuteMs=60000;
      function readSerumState(){
        try{return JSON.parse(window.localStorage.getItem(serumKey) || 'null') || null;}catch(e){return null;}
      }
      function writeSerumState(state){
        try{window.localStorage.setItem(serumKey, JSON.stringify(state));}catch(e){}
      }
      function syncSerumStock(){
        if(!serumCountNode) return;
        var now=Date.now();
        var state=readSerumState();
        if(!state || !Number(state.startedAt)){
          var savedCount=state && Number(state.count);
          var boundedCount=Math.min(serumInitial, Math.max(serumFloor, savedCount || serumInitial));
          var elapsedMinutes=serumInitial - boundedCount;
          state={startedAt:now - (elapsedMinutes * serumMinuteMs)};
          writeSerumState(state);
        }
        var minutesPassed=Math.floor(Math.max(0, now - Number(state.startedAt || now)) / serumMinuteMs);
        var count=Math.max(serumFloor, serumInitial - minutesPassed);
        serumCountNode.textContent=String(count) + '/' + String(serumTotal);
      }
      syncSerumStock();
      window.setInterval(syncSerumStock, 60000);
    }
  }

  var reviewList=document.querySelector('[data-sc-review-list]');
  var reviewButton=document.querySelector('[data-sc-review-more]');
  if(reviewList && reviewButton){
    reviewButton.addEventListener('click',function(){
      var expanded=reviewList.classList.toggle('is-expanded');
      reviewButton.setAttribute('aria-expanded',expanded ? 'true' : 'false');
      var productCopyNode=document.querySelector('[data-product-page]');
      var moreText=productCopyNode ? productCopyNode.getAttribute('data-copy-show-more') : null;
      var fewerText=productCopyNode ? productCopyNode.getAttribute('data-copy-show-fewer') : null;
      reviewButton.textContent=expanded ? (fewerText || 'Show fewer reviews') : (moreText || 'Show more reviews');
    });
  }
})();
